































import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import CTreeSelect from '~/components/shared/configurable/form/select/tree/CTreeSelect.vue'
import { defineComponent, ref, computed, watch } from '~/utils/nuxt3-migration'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { useNamespacedStore } from '~/compositions/store'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: {
    CTreeSelect
  },
  setup(props) {
    const {
      state: classifiedSearchState,
      dispatch: classifiedSearchDispatch
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const { changeParams } = useClassifiedSearchFacet()

    const selectedValues = ref(props.selected || [])

    watch(
      () => props.selected,
      (newSelected: (string | number)[]) => {
        selectedValues.value = newSelected || []
      }
    )

    const rootCategory = computed(
      () => classifiedSearchState.config.rootParams.category
    )

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    function onClear() {
      selectedValues.value = []

      if (props.name === 'category') {
        changeParams([
          { name: props.urlArgNames[0], value: [rootCategory.value] }
        ])
      } else {
        changeParams([
          { name: props.urlArgNames[0], value: selectedValues.value }
        ])
      }
    }

    function onRedirectUrlClick(redirectUrl: string) {
      classifiedSearchDispatch('loadSeoUrlSearch', { seoUrl: redirectUrl })
    }

    function onTreeChange(newValues: (string | number)[]) {
      selectedValues.value = newValues
      changeParams([{ name: props.urlArgNames[0], value: newValues }])
    }

    return {
      selectedValues,
      loadingFacets,
      onClear,
      onTreeChange,
      onRedirectUrlClick
    }
  }
})
